module.exports = __webpack_public_path__ + "static/media/chipped.84e75c71.svg";